/* eslint-disable max-len */
import React, { useCallback } from 'react';
import { useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Image } from '../../../concepts/resources/Image';
import { Menu, Prompt } from '../../../ui';
import { useResolve } from '../../Container';
import { ToolSettings } from '../../canvas/tooling/ToolBehavior';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ConnectorCapStyle, ConnectorMode } from './ConnectorEnums';

export const ConnectorToolWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useObserverReturningStore(useResolve(ToolManager));

    const onSelect = useCallback((settings: ToolSettings) => {
        widget.update({ open: !widget.autoClose });

        tools.setSettings('connectorTool', settings);
        dispatch(toolEquip, ['connectorTool']);

    }, []);

    return <Prompt ignoreMouse ignoreEnter onAction={() => widget.update({ open: false })}>
        <Flexer relative>
            <Menu>
                <Menu.Item onClick={() => onSelect({ mode: ConnectorMode.direct, endCap: ConnectorCapStyle.solidArrow })}>
                    <Image src="deqo://icons/d2/connector-direct" style={{ width: '3rem' }} />
                </Menu.Item>
                <Menu.Item onClick={() => onSelect({ mode: ConnectorMode.smooth, endCap: ConnectorCapStyle.solidArrow })}>
                    <Image src="deqo://icons/d2/connector-smooth" style={{ width: '3rem' }} />
                </Menu.Item>
                <Menu.Item onClick={() => onSelect({ mode: ConnectorMode.manhattan, endCap: ConnectorCapStyle.solidArrow })}>
                    <Image src="deqo://icons/d2/connector-manhattan" style={{ width: '3rem' }} />
                </Menu.Item>
            </Menu>
        </Flexer>
    </Prompt>;
});


